import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const regionService = {
  getProvinces: (params) => {
    const url = `${serverPath}${arsmoApi}/provinces`
    return httpService.httpGet(url, params)
  },
  getCities: (params) => {
    const url = `${serverPath}${arsmoApi}/cities`
    return httpService.httpGet(url, params)
  },
}

export default regionService



// WEBPACK FOOTER //
// ./src/services/region-service.js